// 根据第一个字符是什么就定义是以下哪种文本，如果是中文，则取后位，如：德华（刘德华）；（千玺）易洋千玺；
// 如果是英文：一个单词取首字母，多个单词取前两个词的首字母；
// 如果是数字：取最后一个数字
export function getFormatSpeakerName(input: string): string {
  // 移除所有空白字符
  const trimmedInput = input.replace(/\s/g, '');
  
  if (trimmedInput.length === 0) {
    return '';
  }

  const firstChar = trimmedInput[0];

  // 检查第一个字符是否是中文
  if (/[\u4e00-\u9fa5]/.test(firstChar)) {
    // 中文处理
    const match = trimmedInput.match(/[（(](.*?)[）)]$/);
    if (match) {
      // 如果有括号，取括号内的最后两个字符
      return match[1].slice(-2);
    } else {
      // 如果没有括号，取最后两个字符
      return trimmedInput.slice(-2);
    }
  } else if (/[a-zA-Z]/.test(firstChar)) {
    // 英文处理
    const words = input.trim().split(/\s+/);
    if (words.length === 1) {
      // 如果只有一个单词，取第一个字母
      return words[0][0];
    } else {
      // 如果有多个单词，取前两个单词的首字母
      return (words[0][0] + words[1][0]);
    }
  } else if (/\d/.test(firstChar)) {
    // 数字处理，取最后一个数字
    const lastNumber = trimmedInput.match(/\d(?!.*\d)/);
    return lastNumber ? lastNumber[0] : '';
  }

  // 如果不符合以上任何情况，返回空字符串
  return '';
}